<app-header></app-header>
<app-menu></app-menu>
<div
  class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  style="top: 67px"
>
  <mat-tab-group
  
    mat-align-tabs="center"
    [selectedIndex]="indexTabs.value"
    (selectedIndexChange)="indexTabs.setValue($event)"
    dynamicHeight
  >
    <mat-tab label="" [disabled]="tab1">
      <div [formGroup]="viewprocessorders">
        <div
          class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
          style="margin-top: 17px"
        >
          <mat-form-field
            class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
          >
            <mat-label>Company name</mat-label>
            <mat-select formControlName="SelectCostumerView">
              <input
                matInput
                (keyup)="onKeySearchViewShpping($event.target.value)"
                placeholder="search"
              />

              <mat-option
                *ngFor="let opt of PlaceOrderCustomer2"
                [value]="opt.key"
              >
                {{ opt.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field  class="col-xs-3 col-sm-3 col-md-3 col-3-6 col-xl-3 col-xxl-3">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status">
              <input
                matInput
                
                placeholder="status"
              />

              <mat-option   value="0" >
                Data Entry Not Completed
              </mat-option>
              <mat-option   value="1" >
                Pending
              </mat-option>
              <mat-option   value="2" >
                Warehouse Processing Order
              </mat-option>
             
              <mat-option   value="5" >
                Warehouse Completed Order
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div
            class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
            style="margin-top: 4px"
          >
            <button
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              mat-raised-button
              color="primary"
              (click)="OnChangeSearch()"
            >
              Search
            </button>
          </div>
        </div>
        <mat-progress-spinner mode="indeterminate"> </mat-progress-spinner>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          *ngIf="searchTable"
          style="margin-top: 10px"
        >
          <mat-form-field appearance="outline">
            <input
              matInput
              (keyup)="applyFilter($event.target.value)"
              placeholder="Search"
            />
            <button
              mat-button
              matSuffix
              mat-icon-button
              color="primary"
              (click)="openDialogLectorGeneral(1)"
              aria-label="Example icon button with a menu icon"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
            <mat-hint>Filter table</mat-hint>
          </mat-form-field>

          <div
            class="
			board
              example-container
              mat-elevation-z8
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
          >
            <button
              mat-button
              matSuffix
              mat-icon-button
              color="success"
              (click)="exportAsExcel()"
              aria-label="Example icon button with a menu icon"
              class="col-md-12"
            >
              Excel

              <mat-icon>cloud_download</mat-icon>
            </button>
            <div
              class="example-loading-shade"
              *ngIf="isLoadingResultsView || isRateLimitReachedView"
            >
              <mat-spinner *ngIf="isLoadingResultsView"></mat-spinner>
              <div
                class="example-rate-limit-reached"
                *ngIf="isRateLimitReachedView"
              >
                3plfreightsoftware Werehouse
              </div>
            </div>
            <div class="example-table-container" #exportExcel1>
              <table
                mat-table
                [dataSource]="dataSourceSearch"
                class="example-table"
                matSort
                matSortDirection="desc"
                #TableViewProcessordersSort="matSort"
              >
                <!-- Created Column -->
                <ng-container matColumnDef="options" sticky>
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Options
                  </th>
                  <td mat-cell *matCellDef="let row">
					<button mat-icon-button [matMenuTriggerFor]="menusss" aria-label="Example icon-button with a menu">
						<mat-icon>more_vert</mat-icon>
					  </button>
					  <mat-menu #menusss="matMenu">
						
					 
					  
                    <button
					mat-menu-item                      style="width: 130px; height: 43px"
                      (click)="Oneditar(row)"
                    >
                      Edit
                    </button>
                    <button
					mat-menu-item                      color="success"
                      (click)="OnupdateStatusOrder(row, 1,'3')"
                      style="width: 130px; height: 43px"
                    >
                      Confirm
                    </button>
                    <button
					mat-menu-item                      color="danger"
                      (click)="Onecancelar(row, 1)"
                      style="width: 130px; height: 43px"
                    >
                      Delete
                    </button>
                    <button
					mat-menu-item                      color="primary"
                      (click)="OnFile(row, 2)"
                      style="width: 130px; height: 43px"
                    >
                      Add file
                    </button>
                    <button
					mat-menu-item                      style="width: 130px; height: 43px"
                      color="warning"
                      (click)="openBottomSheet(row)"
                    >
                      <span>Pdf</span>
                    </button>
				</mat-menu>
                  </td>
                </ng-container>
                <!-- Number Column -->
                <ng-container matColumnDef="id">
                  <th mat-header-cell *matHeaderCellDef>#</th>

                  <td mat-cell *matCellDef="let row">
                    {{ row.id }}
                  </td>
                </ng-container>

                <!-- Number Column -->
                <ng-container matColumnDef="PONumber">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">PO #</div>
                  </th>

                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.PONumber }}</div>
                  </td>
                </ng-container>

                <!-- Title Column -->
                <ng-container matColumnDef="RefNumber">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Reference #</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.RefNumber }}</div>
                  </td>
                </ng-container>

                <!-- State Column -->
                <ng-container matColumnDef="ShipDate">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Ship date</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.ShipDate }}</div>
                  </td>
                </ng-container>

                <!-- Created Column -->
                <ng-container matColumnDef="CancelShipDate">
                  <th mat-header-cell *matHeaderCellDef>
                    <div class="theadTable">Cancel ship date</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.CancelShipDate }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Confirmation">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                  Confirmation
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Confirmation }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Comments">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                  Comments
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Comments }}</div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="Notes">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Notes
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.Notes }}</div>
                  </td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="orderStatus">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    <div class="theadTable">Order status</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.orderStatus }}</div>
                  </td>
                </ng-container>
                <!-- Created Column -->
                <ng-container matColumnDef="DateCreated">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    <div class="theadTable">Date created</div>
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <div class="theadTable">{{ row.DateCreated }}</div>
                  </td>
                </ng-container>

                <!-- Created Column -->
                <ng-container matColumnDef="charges">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Charges
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.charges }}</td>
                </ng-container>

                <!-- Created Column -->
                <ng-container matColumnDef="StatusDescription" >
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                    Status
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.StatusDescription }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="Routing" >
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                  Routing
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.Routing }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="Billed" >
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                  Billed
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.Billed }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="AllChargesAdded" stickyEnd>
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    disableClear
                  >
                  AllChargesAdded
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.AllChargesAdded }}
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsViewProcessorders"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="
                    let row;
                    columns: displayedColumnsViewProcessorders
                  "
                ></tr>
              </table>
            </div>

          </div>
		  
		  <mat-paginator
		  [length]="resultsLengthView"
		  #TableViewProcessordersPaginator="matPaginator"
		  [pageSizeOptions]="[50, 100, 250, 1000]"
		  [pageSize]="50"
		></mat-paginator>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Place order" [disabled]="tab2">
      <button
      class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
      *ngIf="!isLDT"
      mat-raised-button
      color="primary"
      (click)="openDialogImportShipping()"
    >
      Import Shipping
    </button>
      <div
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row"
        style="margin-top: 17px"
      >
        <form
          [formGroup]="placeForm"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          style="background: #ffffff29"
        >
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
          >
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
            >
              <mat-form-field>
                <mat-label>Company name</mat-label>
                <mat-select formControlName="SelectCostumerPO">
                  <input
                    matInput
                    (keyup)="onKeySearchShppingPlaceOrder($event.target.value)"
                    placeholder="search"
                  />

                  <mat-option
                    *ngFor="let opt of PlaceOrderCustomer4"
                    [value]="opt.key"
                  >
                    {{ opt.value }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="placeForm.get('SelectCostumerPO').hasError('required')"
                >
                  Company name required.
                </mat-error>
              </mat-form-field>
            </div>
            <div
              class="
                form-group
                col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4
              "
              *ngIf="!isLDT"
            >
              <label for="inputPo">PO #</label>
              <input
                type="text"
                formControlName="inputPo"
                class="form-control"
                maxlength="50"
              />
              <mat-error *ngIf="placeForm.get('inputPo').hasError('required')">
                PO # required
              </mat-error>
            </div>
            <div
            *ngIf="!isLDT"
              class="
                form-group
                col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4
              "
            >
              <label for="inputReferences">Reference #</label>
              <input
                type="text"
                formControlName="inputReferences"
                maxlength="50"
                class="form-control"
              />
            </div>
            <div
            *ngIf="!isLDT"
              class="
                form-group
                col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4
              "
            >
              <label for="inputConfirmation">Confirmation #</label>
              <input
                type="text"
                formControlName="inputConfirmation"
                class="form-control"
                maxlength="150"
              />
            </div>
            <section
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
            >
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              ></div>
              <div
              class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
            >
            <mat-form-field appearance="fill">
              <mat-label>Routing</mat-label>
              <mat-select formControlName="Routing">
                <mat-option [value]="item.key" *ngFor="let item of arrayDescripionRouting">{{item.value}}</mat-option>
               
              </mat-select>
            </mat-form-field>
          
          </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
                style="margin-left: 14vw"
              >
                
                <mat-checkbox formControlName="Billed"
                  class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                  >Billed</mat-checkbox
                >
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              ></div>
            </section>
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
              <mat-form-field color="accent" appearance="fill">
                <mat-label>Ship date</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker1"
                  formControlName="dateShip"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker1"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
                <mat-error
                  *ngIf="placeForm.get('dateShip').hasError('required')"
                >
                  Valid date required.
                </mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="!isLDT" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
              <mat-form-field color="accent" appearance="fill">
                <mat-label>Cancel date</mat-label>
                <input
                  matInput
                  [matDatepicker]="picker2"
                  formControlName="dateCancel"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker2 color="primary"></mat-datepicker>
                <mat-error
                  *ngIf="placeForm.get('dateCancel').hasError('required')"
                >
                  Valid date required.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
              <mat-form-field>
                <mat-label>Status description</mat-label>
                <mat-select formControlName="SelectStatusDescripcion">
                  <mat-option
                    *ngFor="let opt of PlaceOrderStatusDescripcion"
                    [value]="opt.key"
                  >
                    {{ opt.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
              <mat-form-field appearance="fill">
                <mat-label>Order special instructions</mat-label>

                <textarea
                  matInput
                  formControlName="inputOSI"
                  class="form-control"
                ></textarea>
              </mat-form-field>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
              <mat-form-field appearance="fill">
                <mat-label>Comments / Notes</mat-label>
                <textarea
                  matInput
                  formControlName="inputcono"
                  class="form-control"
                ></textarea>
              </mat-form-field>
            </div>

            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                ContentCenter
                btn-group
              "
            >
              <button
                mat-raised-button
                color="danger"
                type="button"
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                (click)="OnCancelEdit()"
              >
                Cancel
              </button>
              <button
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                *ngIf="editarOrder"
                mat-raised-button
                color="primary"
                (click)="EditOrder()"
                type="button"
              >
                Save
              </button>
              <button
                [disabled]="loading"
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                mat-raised-button
                color="primary"
                *ngIf="startOrder"
                (click)="onSubmit()"
                type="button"
              >
                Start order
              </button>
            </div>
          </div>
        </form>
      </div>
    </mat-tab>
    <mat-tab label="Search Orders" [disabled]="tab3">
      <div  class="large-box mat-elevation-z4 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 row">
        <div
          [formGroup]="searchorders"
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
          >
            <div
              class="
                col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3
              "
            >
              <mat-form-field>
                <mat-label>Company name</mat-label>
                <mat-select formControlName="SelectCostumerSO">
                  <input
                    matInput
                    (keyup)="onKeySearchShpping($event.target.value)"
                    placeholder="search"
                  />

                  <mat-option
                    *ngFor="let opt of PlaceOrderCustomer3"
                    [value]="opt.key"
                  >
                    {{ opt.value }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
<div class=" col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
  <mat-form-field>
    <mat-label>Status</mat-label>
    <mat-select formControlName="status">
      <input
        matInput
        
        placeholder="status"
      />

      <mat-option   value="0"    >
        Data Entry Not Completed
      </mat-option>
      <mat-option   value="1"    >
        Pending
      </mat-option>
      <mat-option   value="2"   >
        Warehouse Processing Order
      </mat-option>
      <mat-option   value="5"    >
        Warehouse Completed Order
      </mat-option>

      <mat-option   value="3"    >
        Order Completed
      </mat-option>
      <mat-option   value="4">
        Order Canceled
      </mat-option>
      

      
      
    </mat-select>
  </mat-form-field>
</div>


            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
              <mat-form-field appearance="fill">
                <mat-label>Start date</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickersd"
                  formControlName="startDate"
                  [value]="DefaultFechaInicio.value"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickersd"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickersd></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
              <mat-form-field appearance="fill">
                <mat-label>End date</mat-label>
                <input
                  matInput
                  [matDatepicker]="pickered"
                  formControlName="endDate"
                  [value]="DefaultFechaFin.value"
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="pickered"
                ></mat-datepicker-toggle>
                <mat-datepicker #pickered></mat-datepicker>
              </mat-form-field>
            </div>
            <div
              class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              style="margin-top: 8px"
            >
              <button
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
                mat-raised-button
                color="primary"
                (click)="OnChangeSearchOrder()"
              >
                Search
              </button>
              <button
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              mat-raised-button
              color="primary"
              (click)="OpendialogExportShippingReport()"
            >
            <mat-icon >description</mat-icon>
            Shipping Order
            </button>
            </div>
          </div>
        </div>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          *ngIf="searchTableView"
        >
          <mat-form-field appearance="outline">
            <mat-label>Search</mat-label>
            <input
              matInput
              (keyup)="applyFilterTableSearch($event)"
              placeholder="Search"
              #dataSearch
            />
            <button
              mat-button
              matSuffix
              mat-icon-button
              color="primary"
              (click)="openDialogLectorGeneral(2)"
              aria-label="Example icon button with a menu icon"
            >
              <mat-icon>qr_code_scanner</mat-icon>
            </button>
            <mat-hint>Filter table</mat-hint>
          </mat-form-field>
          <div
            class="
			board
              example-container
              mat-elevation-z8
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
          >
            <button
              mat-button
              matSuffix
              mat-icon-button
              color="success"
              (click)="exportAsExcel2()"
              aria-label="Example icon button with a menu icon"
              class="col-md-12"
            >
              Excel

              <mat-icon>cloud_download</mat-icon>
            </button>
            <div class="example-table-container" #exportExcel2>
              <table
                mat-table
                [dataSource]="dataSourceSearchSO"
                class="example-table"
                matSort
                matSortDirection="desc"
                #TableSearchSort="matSort"
              >
               <!-- Created Column -->
               <ng-container matColumnDef="options" sticky>
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  Options
                </th>
                <td mat-cell *matCellDef="let row">
					<button mat-icon-button [matMenuTriggerFor]="menuTableShi" aria-label="Example icon-button with a menu">
						<mat-icon>more_vert</mat-icon>
					  </button>
					  <mat-menu #menuTableShi="matMenu">
						
						<button
						mat-menu-item
						style="width: 130px; height: 43px"
						(click)="OneditarSearch(row)"
					  >
						Edit
					  </button>
            <button
					  mat-menu-item
						style="width: 150px; height: 43px"
						color="success"
						(click)="OnupdateStatusOrder(row, 2,'1')"
           *ngIf="row.orderStatus=='Data Entry Not Completed'"

					  >
						Pending
					  </button>
					  <button
					  mat-menu-item
						style="width: 150px; height: 43px"
						color="success"
						(click)="OnupdateStatusOrder(row, 2,'2')"
            *ngIf="row.orderStatus=='Data Entry Not Completed'"
					  >
						Process order
					  </button>
            <button
					  mat-menu-item
						style="width: 150px; height: 43px"
						color="success"
						(click)="OnupdateStatusOrder(row, 2,'2')"
            *ngIf="row.orderStatus=='Pending'"
					  >
						Process order
					  </button>
            <button
					  mat-menu-item
						style="width: 150px; height: 43px"
						color="success"
						(click)="OnupdateStatusOrder(row, 2,'3')"
            *ngIf="row.orderStatus=='Pending' && !isLDT"
           
					  >
						Order Completed
					  </button>
            
            <button
					  mat-menu-item
						style="width: 150px; height: 43px"
						color="success"
						(click)="OnupdateStatusOrder(row, 2,'5')"
            *ngIf="row.orderStatus=='Warehouse Processing Order'"
					  >
						Complete order
					  </button>
            <button
					  mat-menu-item
						style="width: 150px; height: 43px"
						color="success"
						(click)="OnupdateStatusOrder(row, 2,'5')"
            *ngIf="row.orderStatus=='Order Completed'"
					  >
						Complete order
					  </button>
					  <button
					  mat-menu-item
						style="width: 130px; height: 43px"
						color="danger"
						(click)="Onecancelar(row, 2)"
					  >
						Cancel
					  </button>
					  <button
					  mat-menu-item
						style="width: 130px; height: 43px"
						color="primary"
						(click)="OnFile(row, 1)"
					  >
						Add file
					  </button>
					  <button
					  mat-menu-item
						style="width: 130px; height: 43px"
						color="warning"
						(click)="openBottomSheet(row)"
					  >
						<span>Pdf</span>
				  </button>
					  </mat-menu>
					  


                </td>
              </ng-container>
              <!-- Number Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>#</th>

                <td mat-cell *matCellDef="let row">
                  {{ row.id }}
                </td>
              </ng-container>

              <!-- Number Column -->
              <ng-container matColumnDef="PONumber" >
                <th mat-header-cell *matHeaderCellDef >
                  <div class="theadTable">PO #</div>
                </th>

                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.PONumber }}</div>
                </td>
              </ng-container>

              <!-- Title Column -->
              <ng-container matColumnDef="RefNumber">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="theadTable">Reference #</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.RefNumber }}</div>
                </td>
              </ng-container>

              <!-- State Column -->
              <ng-container matColumnDef="ShipDate">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="theadTable">Ship date</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.ShipDate }}</div>
                </td>
              </ng-container>

              <!-- Created Column -->
              <ng-container matColumnDef="CancelShipDate">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="theadTable">Cancel After Day(CAD)</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.CancelShipDate }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="Confirmation">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                Confirmation
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.Confirmation }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="Comments">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                Comments
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.Comments }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="Notes">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  Notes
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.Notes }}</div>
                </td>
              </ng-container>
              <!-- Created Column -->
              <ng-container matColumnDef="orderStatus">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <div class="theadTable">Order status</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.orderStatus }}</div>
                </td>
              </ng-container>
              <!-- Created Column -->
              <ng-container matColumnDef="DateCreated">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  <div class="theadTable">Date created</div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <div class="theadTable">{{ row.DateCreated }}</div>
                </td>
              </ng-container>

              <!-- Created Column -->
              <ng-container matColumnDef="charges">
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  Charges
                </th>
                <td mat-cell *matCellDef="let row">{{ row.charges }}</td>
              </ng-container>

              <!-- Created Column -->
              <ng-container matColumnDef="StatusDescription" >
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                  Status
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.StatusDescription }}
                </td>
              </ng-container>
              <ng-container matColumnDef="Routing" >
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                Routing
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.Routing }}
                </td>
              </ng-container>
              <ng-container matColumnDef="Billed" stickyEnd >
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                >
                Billed
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.Billed }}
                </td>
              </ng-container>
              <ng-container matColumnDef="AllChargesAdded"  stickyEnd>
                <th
                  mat-header-cell
                  *matHeaderCellDef
                  mat-sort-header
                  disableClear
                  
                >
                AllChargesAdded
                </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.AllChargesAdded }}
                </td>
              </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="displayedColumnsSearch0rders"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumnsSearch0rders"
                ></tr>
              </table>
            </div>
          </div>

          <mat-paginator
            [length]="resultsLength"
            #TableSearchPaginator="matPaginator"
            [pageSize]="50"
            [pageSizeOptions]="[50, 100, 250, 1000,1500]"
          ></mat-paginator>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Browse files" [disabled]="tab4">
      <div>
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
          >
            <button
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              mat-raised-button
              color="danger"
              (click)="OnCancelFile()"
              *ngIf="cancelFile"
            >
              cancel
            </button>
            <button
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              mat-raised-button
              color="danger"
              (click)="OnCancelFileSearch()"
              *ngIf="!cancelFile"
            >
              cancel
            </button>
          </div>
          <div
            class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
          >
            <div
              class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              style="margin-top: 9px"
            >
              <mat-form-field
                appearance="fill"
                class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                "
              >
                <mat-label>Type of document</mat-label>
                <mat-select (selectionChange)="onedoctype($event)">
                  <mat-option
                    *ngFor="let datos of ArrayDataTypeDocument"
                    [value]="datos"
                    >{{ datos.value }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <div class="center" *ngIf="OcultarContenedor">
            <ngx-file-drop
              dropZoneLabel="Drop files here"
              (onFileDrop)="dropped($event)"
              (onFileOver)="fileOver($event)"
              (onFileLeave)="fileLeave($event)"
            >
              <ng-template
                ngx-file-drop-content-tmp
                let-openFileSelector="openFileSelector"
              >
                <div
                  class="
                    col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                    row
                  "
                >
                  <button
                    type="button"
                    (click)="openFileSelector()"
                    mat-raised-button
                    color="primary"
                    class="
                      col-xs-12
                      col-sm-12
                      col-md-12
                      col-lg-12
                      col-xl-12
                      col-xxl-12
                    "
                  >
                    Browse Files
                  </button>
                  <P
                    style="text-align: center; top: 2vh"
                    class="
                      col-xs-12
                      col-sm-12
                      col-md-12
                      col-lg-12
                      col-xl-12
                      col-xxl-12
                    "
                  >
                    Upload Document</P
                  >
                </div>
              </ng-template>
            </ngx-file-drop>
            <div
              class="
                upload-table
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              style="margin-top: 6vh"
            >
              <table class="table table-dark table-striped">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>url</th>
                  </tr>
                </thead>
                <tbody class="upload-name-style">
                  <tr *ngFor="let item of arrayfiles; let i = index">
                    <td>
                      <strong>{{ item.file }}</strong>
                    </td>
                    <td>
                      <a
                        [href]="item.fileurl"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <button mat-raised-button color="primary">
                          View Document
                          <mat-icon>phonelink</mat-icon>
                        </button>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>
